
import { useState } from 'react';

export default function DealershipFAQ() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What is included in the dealership investment?',
      answer: 'Your investment includes premium glamping products, complete POS and booking systems, comprehensive marketing materials, training programs, territory rights, and ongoing support. No additional franchise fees or royalties are required.'
    },
    {
      question: 'How much territory do I get with my dealership?',
      answer: 'Territory size depends on your investment package. Starter packages cover populations up to 50,000, Growth packages up to 150,000, and Premium packages up to 500,000. We ensure exclusive territory protection for all dealers.'
    },
    {
      question: 'What kind of training is provided?',
      answer: 'We provide comprehensive training covering product knowledge, sales techniques, installation procedures, business operations, marketing strategies, and customer service. Training includes both online modules and in-person sessions.'
    },
    {
      question: 'Do I need prior experience in the glamping industry?',
      answer: 'No prior glamping experience is required. Our training program is designed to bring you up to speed quickly. However, business experience and sales background are beneficial for success.'
    },
    {
      question: 'What ongoing support do you provide?',
      answer: 'We offer 24/7 technical support, dedicated account management, marketing campaign updates, new product training, business development assistance, and regular performance reviews to ensure your success.'
    },
    {
      question: 'How quickly can I start selling after investment?',
      answer: 'The typical timeline from investment to launch is 8-12 weeks. This includes setup, training, marketing preparation, and initial inventory delivery. We work to get you operational as quickly as possible.'
    },
    {
      question: 'What are the profit margins on products?',
      answer: 'Profit margins vary by product but typically range from 25-40% on glamping structures and 15-25% on systems and accessories. Your account manager will provide detailed pricing and margin information during the application process.'
    },
    {
      question: 'Can I sell online or only locally?',
      answer: 'You can sell both locally and online within your protected territory. We provide e-commerce support and digital marketing tools to help you reach customers through multiple channels.'
    },
    {
      question: 'What financing options are available?',
      answer: 'We work with several financing partners to help qualified applicants secure funding for their dealership investment. Our team can connect you with appropriate financing options based on your situation.'
    },
    {
      question: 'How do I get started with the application process?',
      answer: 'Contact our dealership team to schedule an initial consultation. We\'ll discuss your goals, review available territories, and guide you through the application process. The initial consultation is free and no-obligation.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
          <p className="text-lg text-gray-600">
            Get answers to common questions about our dealership opportunities and investment process.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200">
              <button
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
              >
                <h3 className="font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <i className={`ri-arrow-${openFAQ === index ? 'up' : 'down'}-s-line text-emerald-600 text-xl flex-shrink-0`}></i>
              </button>
              
              {openFAQ === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white rounded-lg p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Still Have Questions?</h3>
            <p className="text-gray-600 mb-6">
              Our dealership specialists are ready to answer any additional questions and help you get started.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:256-268-7146"
                className="bg-emerald-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap"
              >
                Schedule Consultation
              </a>
              <button className="border-2 border-emerald-600 text-emerald-600 px-8 py-3 rounded-lg font-semibold hover:bg-emerald-600 hover:text-white transition-colors whitespace-nowrap">
                Download Info Pack
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
